import React, { useMemo } from 'react';

import { Box, Slider, Typography } from '@mui/material';

import { fmtShortDate } from './utils';

function clampDateIndexRange(range: readonly [number, number], maxIndex: number): [number, number] {
  const cap = Math.max(0, maxIndex);
  let lo = Math.max(0, Math.min(range[0], cap));
  let hi = Math.max(0, Math.min(range[1], cap));
  if (lo > hi) {
    [lo, hi] = [hi, lo];
  }
  return [lo, hi];
}

interface Props {
  dates: Array<string>;
  range: [number, number];
  onRangeChange: (range: number[]) => void;
}

export default function DateRangeSlider({ dates, range, onRangeChange }: Props) {
  const max = Math.max(0, dates.length - 1);
  const value = useMemo(() => clampDateIndexRange(range, max), [range, max]);

  return (
    <Box sx={{ bgcolor: 'grey.50', p: 3, borderRadius: '12px', border: 1, borderColor: 'divider', mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>Date Range</Typography>
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: 'primary.main' }}>
          {fmtShortDate(dates[value[0]] ?? '')} - {fmtShortDate(dates[value[1]] ?? '')}
        </Typography>
      </Box>
      <Slider
        value={value}
        onChange={(_, val) => onRangeChange(val as number[])}
        min={0}
        max={max}
        color="primary"
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{fmtShortDate(dates[0] ?? '')}</Typography>
        <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{fmtShortDate(dates[max] ?? '')}</Typography>
      </Box>
    </Box>
  );
}
